import React, { useContext, useState } from 'react';
import { Outlet, useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Loading, Icon } from 'components';
import { NewPatientSideBar } from './NewPatientSideBar';
import { PatientProvider } from 'contexts';
import { PatientContext } from 'contexts/PatientContext';

export const NewPatientLayout = () => {
	const { t } = useTranslation();
	const [loading, setLoading] = useState(true);
	const { patientId } = useParams();
	const navigate = useNavigate();
	const { fetching } = useContext<any>(PatientContext);

	return !fetching ? (
		<PatientProvider patientId={patientId}>
			<div className='flex justify-end flex-row min-h-screen'>
				<NewPatientSideBar className='lg:w-[472px] sticky top-0 left-0 h-screen' />
				<div className='py-12 grow relative'>
					<div className='max-w-3xl mx-auto'>
						<div className='flex flex-row justify-end'>
							<Button
								type='link'
								className='flex items-center font-medium'
								textColor='grey-text'
								to={!patientId ? '/patients' : `/patient/${patientId}`}
							>
								<Icon
									name='BackArrowSmall'
									height={14}
									className='mr-2'
								/>
								{patientId ? t('goBackToPatientFile') : t('exit')}
							</Button>
						</div>
						<Outlet />
					</div>
				</div>
			</div>
		</PatientProvider>
	) : (
		<Loading />
	);
};
